<template>
  <transition name="fade" @after-leave="onAfterLeave">
    <div class="dialog toast" :class="toastStyle" v-if="visible">
      <div class="dialog-modal" v-html="message" v-if="type == 'info'"></div>
      <div class="dialog-modal" v-if="type == 'loading'">
        <img class="icon" src="@/assets/images/loading.png" alt="loading">
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info'
  },
  full: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: ''
  },
  duration: {
    type: Number,
    default: 2000
  },
  hide: {
    type: Function,
    default: () => {}
  }
})

const toastStyle = computed(() => {
  const style = props.full ? 'full' : ''
  return `${props.type} ${style}`
})

const visible = ref(false)
const timer = ref(null)
const lock = ref(false)

function show() {
  visible.value = true
  lock.value = true
  lockClick()
  clearTimeout(timer.value) // 之前的未关闭，需要清除，保障全局唯一性
  if(props.type == 'info') {
    timer.value = setTimeout(() => {
      clear()
    }, props.duration)
  }
}
function clear() {
  visible.value = false
  lock.value = false
  lockClick()
}
function lockClick() {
  if (lock.value) {
    document.body.classList.add('unclickable')
  } else {
    document.body.classList.remove('unclickable')
  }
}
function onAfterLeave() {
  props.hide()
}
defineExpose({
  show, clear
})
</script>
